import { connect } from 'react-redux';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { Stack } from '@optimus-web/core';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { UnicodeEntity } from '@mews/enums';
import { Reservation } from '@mews-commander/data-access';
import { getResourceCategoryIdByResourceId } from '@mews-commander/legacy-entities/src/ducks/resourceCategoryAssignments';
import { fetchCurrentEnterpriseReservationsByReservationIds } from '@mews-commander/legacy-entities/src/actions';
import { ModalLink, ResourceCategoryName } from '../../../../../components';
import { RESERVATION_BARE_MINIMUM_EXTENT } from '../../../constants';
import ResourceLockedToggle from '../../ResourceLockedToggle';
import { ResourceName } from '../../../../../components/reservation/ResourceName';
import UpgradedResourceCategoryIcon from './UpgradedResourceCategoryIcon';

type OwnProps = Pick<Reservation, 'assignedResourceId' | 'requestedCategoryId' | 'serviceId' | 'id'>;
interface StateProps {
    assignedResourceCategoryId: string | undefined;
}

interface DispatchProps {
    fetchReservation: () => Promise<void>;
}

type Props = StateProps & OwnProps & DispatchProps;

const ResourceContent = ({
    id,
    assignedResourceId,
    assignedResourceCategoryId,
    requestedCategoryId,
    serviceId,
    fetchReservation,
}: Props) => {
    const resolveRoute = useResolveRoute();

    if (assignedResourceId === null || assignedResourceCategoryId === undefined) {
        return <ResourceCategoryName id={requestedCategoryId} serviceId={serviceId} short tooltipped />;
    }

    const url = resolveRoute(RouteName.ResourceState, { id: assignedResourceId });

    return (
        <>
            <Stack spacing="200">
                <div>
                    <ResourceCategoryName id={assignedResourceCategoryId} serviceId={serviceId} short tooltipped />
                    {UnicodeEntity.NoBreakSpace}
                    <ModalLink url={url}>
                        {assignedResourceId && <ResourceName resourceId={assignedResourceId} />}
                    </ModalLink>
                </div>

                <Stack spacing="100">
                    {assignedResourceCategoryId !== requestedCategoryId ? (
                        <UpgradedResourceCategoryIcon requestedCategoryId={requestedCategoryId} serviceId={serviceId} />
                    ) : null}
                    <ResourceLockedToggle reservationId={id} onSuccess={fetchReservation} />
                </Stack>
            </Stack>
        </>
    );
};

export default connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    (state, { assignedResourceId, serviceId }) => ({
        assignedResourceCategoryId:
            assignedResourceId != null
                ? getResourceCategoryIdByResourceId(state, {
                      resourceId: assignedResourceId,
                      serviceId,
                  })
                : undefined,
    }),
    (dispatch: CommanderThunkDispatch, { id }) => ({
        fetchReservation: async () => {
            await dispatch(
                fetchCurrentEnterpriseReservationsByReservationIds({
                    reservationIds: [id],
                    extent: RESERVATION_BARE_MINIMUM_EXTENT,
                })
            );
        },
    })
)(ResourceContent);
